import React, { useEffect, useState } from "react";
import axios from "../../api/axios";
import PermissionGuard from "../../components/auth/PermissionGuard";

export default function PermissionsPage() {
  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    axios.get("/admin/permissions").then((res) => {
      setPermissions(res.data?.data || {});
    });
  }, []);

  return (
    <PermissionGuard permission="security.permissions.view">
      <div>
        <h2>Permissions</h2>

        <div style={{ background: "#fff", padding: 16, borderRadius: 12 }}>
          {Object.entries(permissions).map(([module, items]) => (
            <div key={module} style={{ marginBottom: 24 }}>
              <h3>{module}</h3>
              <table width="100%" cellPadding="8">
                <thead>
                  <tr>
                    <th align="left">Name</th>
                    <th align="left">Code</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((permission) => (
                    <tr key={permission.id}>
                      <td>{permission.name}</td>
                      <td>{permission.code}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </PermissionGuard>
  );
}
